
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import eventBus from '@/utils/eventBus';
import { OrderStage } from '@/types/orderComplaint';
import { IPagination } from '@/types';
import bbsDialog from '@/components/BbsDialog/index.vue';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import DialogOrderDetail from '@/components/OrderDetail/index.vue';
import columnItemLatest from "../../orderServicer/components/OrderColumn.vue";
// import DrawerDetail from '@/components/Drawer/DrawerDetail.vue';

import { complain, getOrderComplaintList } from '@/api/orderComplaint';
import { exportOrderComplaint, getOrderDispose, getOrderServiceProgressList } from '@/api/orderService';
import { getTaskProgressList } from '@/api/orderTask';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';

@Component({
  name: 'orderComplaintList',
  components: {
    dialogImgLarge,
    DialogOrderDetail,
    bbsDialog,
    columnItemLatest,
    // DrawerDetail
  }
})
export default class extends Vue {
  private listLoading = false
  private orderList = []

  @Prop({
    type: Number,
    default: OrderStage.UNTREATED,
    required: true,
    validator: (value:any) => OrderStage[value] !== undefined
  })
  private stage!: OrderStage;

  private orderParams: any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    page: 1,
    size: 10,
    is_need_task: 1
  }
  // @Watch('orderParams', { deep: true, immediate: true })
  // onParamsChange() {
  //   this.getList();
  // }
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 1,
    total: 0
  }
  private searchParams:any={}

  private columnItemIsHidden = false;

  created() {
    let that = this;
    if (this.stage !== 8) {
      that.getList();
    }
    eventBus.$on('orderServicerOrderSearch', function(data:any) {
      that.searchParams = data;
      that.pagination.currentPage = 1;
      that.getList();
    });
  }
  beforeDestroy() {
    eventBus.$off('orderServicerOrderSearch');
  }
  getList() {
    this.orderList = []
    this.listLoading = true;
    const params = {
      complaint_state: this.stage,
      ...this.orderParams,
      ...this.searchParams
    };
    getOrderComplaintList(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.pagination.currentPage = parseInt(data.page_current);
        this.pagination.total = parseInt(data.count);
        this.pagination.pageSize = parseInt(data.page_size);
        this.orderList = data.list;
      } else {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.orderList = [];
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  private columnItem: any = {
    trouble_describle: { name: '故障信息', value: '0', checked: true },
    customer: { name: '报修方', value: '1', checked: true },
    person: { name: '联系人', value: '2', checked: true },
    address: { name: '联系地址', value: '4', checked: true },
    progress: { name: '订单进度', value: '3', checked: true },
    price: { name: '预估费用', value: '7', checked: true },
    real_price: { name: '实际收费', value: '8', checked: true },
    addtime: { name: '报修时间', value: '9', checked: true },
    operate: { name: '操作', value: '10', checked: true }
  }
  private exportExcel() {
    const params = {
      ...this.orderParams,
      ...this.searchParams
    };
    exportOrderComplaint(params).then((res:any) => {
      if (res) {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      }
    }).catch(() => {
    });
  }

  // private settingColumnItem = false
  // showHideColumn() {
  //   this.settingColumnItem = !this.settingColumnItem;
  // }

  getTagsHtml(r:any) {
    let kind = ''; let kindType = ''; let plain = 'plain';
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let charge = ''; let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 2019-05-23 迭代 订单排位
    var ranking = '';
    if (parseInt(r.order_service.is_ranking) === 1) {
      var rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + '号';
      }
    }

    // 审核标识
    let check = '';
    if (parseInt(r.order.check_state) === 11 || parseInt(r.order.check_state) === 51) {
      check = '审核';
    }

    return [{
      type: kindType, label: kind, plain: plain
    }, {
      type: 'danger', label: charge, plain: darkplain
    }, {
      type: 'danger', label: expedited, plain: darkplain
    }, {
      type: 'danger', label: ranking, plain: darkplain
    }, {
      type: 'warning', label: check, plain: darkplain
    }];
  }
  complaintBtn(row:any) {
    return checkPermissionUseAndCompany(UserModule.getCompanyId, Type.ORDER_COMPLAINT_DEAL);
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  handleCurrentChange(size:number) {
    this.orderParams.page = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.orderParams.size = size;
    this.getList();
  }

  private dialogOrderDetailVisible = false;
  private detail = {};
  private task = {};
  private orderProgressData = {};
  private isOrderTask = false;
  private isOrderProgress = false;
  private showComplaintBtn=false;
  private showBJD=false;

  private showDrawerDetails =false;
  private DetailsDataQuery: any = {};
  private closeDrawerDetail(val:boolean) {
    this.showDrawerDetails = val
  }
  // 订单详情
  detailHandle(val: any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
      }
    });
    window.open(routeData.href);

    // this.showDrawerDetails = true;
    // this.DetailsDataQuery = {
    //   order_service_id: val.order_service.id,
    //   company_id: val.order_service.servicer_company_id,
    // };
  }

  // 任务详情
  private isOrderEnterTask=false
  detailOrderTask(row: any, current: any, type: number) {
    this.isOrderEnterTask = true;
    this.dialogOrderDetailVisible = true;
    this.detail = row;
    this.task = current;
    this.isOrderTask = true;

    let p = {};
    (p as any).user_id = UserModule.getUserId;
    (p as any).company_id = UserModule.getCompanyId;
    (p as any).order_service_id = row.order_service.id;
    (p as any).order_id = row.order.id;
    (p as any).user_name = UserModule.getUserName;
    getTaskProgressList(p)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.orderProgressData = data;
        } else {
          this.orderProgressData = {};
        }
      })
      .catch((err) => {
        let msg = err.msg;
        this.orderProgressData = {};
      });

    if (type === 2) {
      this.isOrderProgress = true;
    } else {
      this.isOrderProgress = false;
    }
  }
  closeDetailHandle(value:boolean) {
    this.dialogOrderDetailVisible = value;
  }

  private nowId: number = -1;
  private nowSid: number = -1;
  private bbsDialogVisible: boolean = false;
  // 不根据state判断，所以永远置为1
  private state: number = 1;
  private complaintState:number = 1;
  bbsHandle(r: any) {
    this.nowId = parseInt(r.order.id);
    this.nowSid = parseInt(r.order_service.id);
    if (parseInt(r.order_service.complaint_state) === 2) {
      const params = {
        order_id: this.nowId,
        order_service_id: this.nowSid,
        // 点开，状态设置为5
        complaint_state: 5
      };
      complain(params)
        .then((res) => {
          this.complaintState = 5;
        })
        .catch(() => {
        });
    } else {
      this.complaintState = parseInt(r.order_service.complaint_state);
    }
    this.bbsDialogVisible = true;
  }
  closeBbs(value: boolean, refresh?: boolean) {
    this.bbsDialogVisible = value;
    if (refresh !== undefined && refresh) {
      this.getList();
    }
  }
}
